<template>
  <div class="mainBox">
    <!-- <div class="topBox">
          <div v-for="(item,index) in navList" :key="index" @click="toPage(item)">
              <span>{{item.label}}</span>
              <img :src="item.src" alt="">
          </div>
      </div>
      <div class="content">
          <div class="title">
              <img src="@/assets/bussiessImgs/shoufeitongji.png" alt="">
              <span>收费统计</span>
          </div>
          <div class="itemBox">
              <div class="total">
                  <p>应收金额<span>{{payData.total}}</span> 元</p>
              </div>
            <Progress :percent='payData.percent'></Progress>
              <div class="amt">
                  <span>已收金额{{payData.confirm}}元</span>
              </div>
          </div>
          <div class="itemBox">
              <div class="total">
                  <p>应收笔数<span>{{payData.countTotal}}</span> 笔</p>
              </div>
            <Progress :percent='payData.countPercent' color='#4ACC9F' bgColor='#CFE6F6'></Progress>
              <div class="amt">
                  <span>已收笔数{{payData.count}}笔</span>
              </div>
          </div>

      </div> -->
    <div class="main_top">
      <img src="../../assets/img/tyindex.png" alt="" />
    </div>
    <!-- 有统计的情况 -->
    <div
      :class="[
        (flagObject.queryFlag &&
          !flagObject.addFlag &&
          !flagObject.payFlag &&
          !flagObject.paidFlag) ||
        (!flagObject.queryFlag &&
          flagObject.addFlag &&
          !flagObject.payFlag &&
          !flagObject.paidFlag) ||
        (!flagObject.queryFlag &&
          !flagObject.addFlag &&
          flagObject.payFlag &&
          !flagObject.paidFlag) ||
        (!flagObject.queryFlag &&
          !flagObject.addFlag &&
          !flagObject.payFlag &&
          flagObject.paidFlag)
          ? 'main_midrow'
          : 'main_mid'
      ]"
      v-if="flagObject.accountFlag"
    >
      <div
        :class="[
          index == 0 &&
          flagObject.queryFlag &&
            !flagObject.addFlag &&
            !flagObject.payFlag &&
            !flagObject.paidFlag&&
            !flagObject.payerFlag
            ? 'firh'
            : index == 0 &&
              !(
                flagObject.queryFlag &&
                !flagObject.addFlag &&
                !flagObject.payFlag &&
                !flagObject.paidFlag&&
                !flagObject.payerFlag
              )
            ? 'fir'
            : index == 2 &&
              !flagObject.queryFlag &&
                flagObject.addFlag &&
                !flagObject.payFlag &&
                !flagObject.paidFlag&&
            !flagObject.payerFlag
            ? 'sech'
            : index == 2 &&
              !(
                !flagObject.queryFlag &&
                flagObject.addFlag &&
                !flagObject.payFlag &&
                !flagObject.paidFlag&&
            !flagObject.payerFlag
              )
            ? 'sec'
            : index == 3 &&
              !flagObject.queryFlag &&
                !flagObject.addFlag &&
                flagObject.payFlag &&
                !flagObject.paidFlag&&
            !flagObject.payerFlag
            ? 'thrh'
            : index == 3 &&
              !(
                !flagObject.queryFlag &&
                !flagObject.addFlag &&
                flagObject.payFlag &&
                !flagObject.paidFlag&&
            !flagObject.payerFlag
              )
            ? 'thr'
            : index == 4 &&
              !flagObject.queryFlag &&
                !flagObject.addFlag &&
                !flagObject.payFlag &&
                flagObject.paidFlag&&
            !flagObject.payerFlag
            ? 'forh'
            : index == 4 &&
              !(
                !flagObject.queryFlag &&
                !flagObject.addFlag &&
                !flagObject.payFlag &&
                flagObject.paidFlag&&
            !flagObject.payerFlag
              )
            ? 'for'
            :  index == 1 &&
              !flagObject.queryFlag &&
                !flagObject.addFlag &&
                !flagObject.payFlag &&
                !flagObject.paidFlag&&
                flagObject.payerFlag
            ? 'fifh'
            : index == 1 &&
              !(
                !flagObject.queryFlag &&
                !flagObject.addFlag &&
                !flagObject.payFlag &&
                !flagObject.paidFlag&&
                flagObject.payerFlag
              )
            ? 'fif'
            :''
        ]"
        v-show="
          (item.label == '查询' && flagObject.queryFlag) ||
            (item.label == '新增' && flagObject.addFlag) ||
            (item.label == '未支付' && flagObject.payFlag) ||
            (item.label == '已支付' && flagObject.paidFlag)||
            (item.label == '缴款人' && flagObject.payerFlag)
        "
        v-for="(item, index) in navList"
        :key="index"
        @click="toPage(item)"
      >
        <span>{{ item.label }}</span>
        <img class="mid_src" :src="item.src" alt="" />
      </div>
    </div>
    <!-- 没有统计模块时，全部横着排列 -->
    <div class="main_midrow" v-if="!flagObject.accountFlag">
      <div
        :class="[
          index == 0
            ? 'firh'
            : index == 1
            ? 'sech'
            : index == 2
            ? 'sech'
            : index == 3
            ? 'thrh'
            : index == 4
            ? 'forh'
            : ''
        ]"
        v-show="
          (item.label == '查询' && flagObject.queryFlag) ||
            (item.label == '新增' && flagObject.addFlag) ||
            (item.label == '未支付' && flagObject.payFlag) ||
            (item.label == '已支付' && flagObject.paidFlag)||
            (item.label == '缴款人' && flagObject.payerFlag)
        "
        v-for="(item, index) in navListRow"
        :key="index"
        @click="toPage(item)"
      >
        <span>{{ item.label }}</span>
        <img class="mid_src" :src="item.src" alt="" />
      </div>
    </div>
    <!-- 统计图 -->
    <div class="mid_bot" v-if="flagObject.accountFlag">
      <div class="m_top">
        <img src="../../assets/img/tytotal.png" alt="" />
        <span>收费统计</span>
      </div>
      <div class="m_mid">
        <div class="chartBox">
          <div id="chart" :style="{ width: '82px', height: '82px' }"></div>
        </div>
        <div class="countM">
          <div class="pay">
            <span class="payTol">应收金额</span>
            <br />
            <span class="payNo">{{ payData.total }}元</span>
          </div>
          <div class="alreadyPay">
            <span class="payTol">已收金额</span>
            <br />
            <span class="payNo">{{ payData.confirm }}元</span>
          </div>
        </div>
      </div>
      <div class="m_bot">
        <div class="chartBox" style="padding-top: 10px">
          <div id="chartFul" :style="{ width: '82px', height: '82px' }"></div>
        </div>
        <div class="countM">
          <div class="pay">
            <span class="payTol">应收笔数</span>
            <br />
            <span class="payNo">{{ payData.countTotal }}笔</span>
          </div>
          <div class="alreadyPay">
            <span class="payTol">已收笔数</span>
            <br />
            <span class="payNo">{{ payData.count }}笔</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUser } from "@/utils/common";
//  import eventBus from '@/utils/eventbus';
import Progress from "./components/progress.vue";
export default {
  components: {
    Progress
  },
  data() {
    return {
      navList: [
        {
          label: "查询",
          url: "",
          icon: "icon-fangda",
          url: "/bussiess/search",
          src: require("@/assets/img/cxpic.png")
        },
        {
          label: "缴款人",
          url: "",
          icon: "icon-xiezi",
          url: "/bussiessIndex/payerList",
          src: require("@/assets/img/paymentUnitpic.png")
        },
        {
          label: "新增",
          url: "",
          icon: "icon-xiezi",
          url: "/bussiess/add",
          src: require("@/assets/img/cxadd.png")
        },
        {
          label: "未支付",
          url: "",
          icon: "icon-huobi",
          url: "/bussiess/payList",
          user: true,
          src: require("@/assets/img/cxwzf.png")
        },
        {
          label: "已支付",
          url: "",
          icon: "icon-youjian",
          url: "/bussiess/paidList",
          isConfirm: "1",
          src: require("@/assets/img/cxyzf.png")
        },
        
      ],
      navListRow: [
        {
          label: "查询",
          url: "",
          icon: "icon-fangda",
          url: "/bussiess/search",
          src: require("@/assets/img/row_icon.png")
        },
        {
          label: "缴款人",
          url: "",
          icon: "icon-fangda",
          url: "/bussiessIndex/payerList",
          src: require("@/assets/img/paymentUnitpic.png")
        },
        {
          label: "新增",
          url: "",
          icon: "icon-xiezi",
          url: "/bussiess/add",
          src: require("@/assets/img/add_icon.png")
        },
        {
          label: "未支付",
          url: "",
          icon: "icon-huobi",
          url: "/bussiess/payList",
          user: true,
          src: require("@/assets/img/pay_icon.png")
        },
        {
          label: "已支付",
          url: "",
          icon: "icon-youjian",
          url: "/bussiess/paidList",
          isConfirm: "1",
          src: require("@/assets/img/paid_icon.png")
        }
      ],
      payData: {},
      flagObject: {
        // 判断开关数据
        queryFlag: false,
        addFlag: false,
        payerFlag:false,
        payFlag: false,
        paidFlag: false,
        accountFlag: false
      },
      tyConfigObj: {}
    };
  },
  created() {
    // 获取配置
    // this.getConfig();
    // console.log((this.flagObject.queryFlag&&!this.flagObject.addFlag&&!this.flagObject.payFlag&&!this.flagObject.paidFlag)||(!this.flagObject.queryFlag&&this.flagObject.addFlag&&!this.flagObject.payFlag&&!this.flagObject.paidFlag)||(!this.flagObject.queryFlag&&!this.flagObject.addFlag&&this.flagObject.payFlag&&!this.flagObject.paidFlag)||(!this.flagObject.queryFlag&&!this.flagObject.addFlag&&!this.flagObject.payFlag&&this.flagObject.paidFlag))
  },
  mounted() {
    setTimeout(() => {
      this.getConfigMsg();
    }, 200);
  },
  // activated(){
  //   //根据key名获取传递回来的参数，data就是map
  //   eventBus.$on('addressInfo', function(data){
  //     // this.$emit('changeActive',data.active)
  //   }.bind(this));
  // },
  methods: {
    getConfigMsg() {
      // if (localStorage.getItem("flagObj")) {
      //   this.flagObject = JSON.parse(localStorage.getItem("flagObj"));
      //   if (this.flagObject.accountFlag) {
      //     this.getData();
      //   }
      // }
      // 先获取配置回显
      this.request({
        url: "/systemManage/getMobileFunConfig",
        method: "get",
        params: {
          deptId: getUser().deptId,
          businessType: "businessDoorPayment"
        }
      }).then(res => {
        if (res.data.code === 1000) {
          if (res.data.result) {
            this.tyConfigObj = res.data.result;
            if(this.tyConfigObj.funcation){
              this.tyConfigObj.funcation.forEach(item=>{
                if(item.fieldValue=='add'){
                  this.flagObject.addFlag=item.enable;
                }
                if(item.fieldValue=='query'){
                  this.flagObject.queryFlag=item.enable;
                }
                if(item.fieldValue=='unPay'){
                  this.flagObject.payFlag=item.enable;
                }
                if(item.fieldValue=='pay'){
                  this.flagObject.paidFlag=item.enable;
                }
                if(item.fieldValue=='payer'){
                  this.flagObject.payerFlag=item.enable;
                }
                
                if(item.fieldValue=='statistic'){
                  this.flagObject.accountFlag=item.enable;
                  if(this.flagObject.accountFlag){
                    this.getData();
                  }
                }
              })
              localStorage.setItem('flagObj',JSON.stringify(this.flagObject))
            }
          }
        } else {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            message: res.data.message,
            textSize: 16,
          }).then((res) => {});
        }
      });
    },
    getData() {
      this.request({
        url: "/h5Report/itemByDeptId",
        method: "post",
        params: {
          deptId: getUser().deptId
        }
      }).then(res => {
        if (res.data.code == 1000) {
          this.payData = res.data.result.data;
          let myChart = this.$echarts.init(
            document.getElementById("chart"),
            "macarons"
          );
          myChart.setOption({
            backgroundColor: "#fff",
            // 数据
            series: [
              // 水球形状
              {
                type: "liquidFill",
                // this.payData.percent
                data: [
                  0.01 * this.payData.percent,
                  (this.payData.percent + 2) * 0.01
                ],
                direction: "right", //波浪方向或者静止
                radius: "96%",
                itemStyle: {
                  // color: "linear-gradient(#A1ECC2, #13C96F, #07A05E)", // 水球显示的背景颜色
                  shadowBlur: 0, // 波浪的阴影范围
                  shadowColor: "#fff"
                },
                // 水球颜色
                color: ["#0051CB", "#3689FF", "#7FEBFF"],
                center: ["50%", "50%"], //水球位置
                // outline  外边
                outline: {
                  // show: false
                  borderDistance: 2, //内环padding值
                  itemStyle: {
                    borderWidth: 1, //圆边线宽度
                    borderColor: {
                      type: "linear",
                      colorStops: [
                        {
                          offset: 0, // 边框 0% 处的颜色
                          color: "#1780E9"
                        },
                        {
                          offset: 0.5, // 边框 100% 处的颜色
                          color: "#79CFFF"
                        },
                        {
                          offset: 1, // 边框 100% 处的颜色
                          color: "#1780E9"
                        }
                      ]
                    },
                    shadowBlur: 0,
                    shadowColor: "#fff",
                    color: "#fff"
                  }
                },
                backgroundStyle: {
                  // borderWidth: 5,
                  // borderColor: 'rgb(255,0,255,0.9)',
                  // backgroundColor:'#fff',
                  color: "#fff" // 设置水球背景颜色
                },
                label: {
                  // 百分比数字的位置
                  position: ["50%", "25%"],
                  show: true,
                  fontSize: "16",
                  fontFamily: "AlibabaPuHuiTiB",
                  color: "#464A4C",
                  fontWeight: 700
                }
              }
            ]
          });

          let myChartFul = this.$echarts.init(
            document.getElementById("chartFul"),
            "macarons"
          );
          myChartFul.setOption({
            backgroundColor: "#fff",
            series: [
              {
                type: "liquidFill",
                data: [
                  this.payData.countPercent * 0.01,
                  (this.payData.countPercent + 2) * 0.01
                ],
                direction: "right", //波浪方向或者静止
                radius: "96%",
                // 水球颜色
                color: ["#A1ECC2", "#07A05E"],
                center: ["50%", "50%"], //水球位置
                // outline  外边
                outline: {
                  // show: false
                  borderDistance: 2, //内环padding值
                  itemStyle: {
                    borderWidth: 1, //圆边线宽度
                    // borderColor: "#13C96F",
                    shadowBlur: 0,
                    shadowColor: "#fff",
                    color: "#fff",
                    borderColor: {
                      type: "linear",
                      colorStops: [
                        {
                          offset: 0, // 边框 0% 处的颜色
                          color: "#0CB56C"
                        },
                        {
                          offset: 0.5, // 边框 100% 处的颜色
                          color: "#A1ECC2"
                        },
                        {
                          offset: 1, // 边框 100% 处的颜色
                          color: "#0CB56C"
                        }
                      ]
                    }
                  }
                },
                backgroundStyle: {
                  // borderWidth: 5,
                  // borderColor: 'rgb(255,0,255,0.9)',
                  shadowColor: "transparent",
                  backgroundColor: "transparent",
                  color: "#fff"
                },
                label: {
                  position: ["50%", "25%"],
                  show: true,
                  fontSize: "16",
                  fontFamily: "AlibabaPuHuiTiB",
                  color: "#464A4C",
                  fontWeight: 700
                },
                itemStyle: {
                  // color: "linear-gradient(#A1ECC2, #13C96F, #07A05E)", // 水球显示的背景颜色
                  shadowBlur: 0, // 波浪的阴影范围
                  shadowColor: "#fff"
                }
              }
            ]
          });
        }
      });
    },
    toPage(item) {
      // 清除查询缓存
      if (localStorage.getItem("forceCashUpd")) {
            localStorage.removeItem("forceCashUpd");
          }
          if (localStorage.getItem("paramsObj")) {
            localStorage.removeItem("paramsObj");
          }
          if (localStorage.getItem("currentValueCash")) {
            localStorage.removeItem("currentValueCash");
          }
      this.$router.push({
        path: item.url,
        query: {
          vde: this.$route.query.vde,
          // userCode:getUser().userName,
          active: 0
        }
      });
      this.$emit('act');
    }
  }
};
</script>

<style lang='scss' scoped>
.mainBox {
  // min-height: 100vh;
  padding-top: 20px;
  padding-bottom: 70px;
  box-sizing: border-box;
  font-family: "微软雅黑";
  background: url("../../assets/img/queryBW.png");
  background-size: cover;
  height: 100vh;
  overflow-y: auto;
}
.main_top {
  padding-right: 16px;
  text-align: right;
  > img {
    width: 256px;
    height: 151px;
  }
}
.main_mid {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  // padding:0px 15px;
  width: 100vw;
  box-sizing: border-box;
  padding: 0px 14px;
  > div {
    display: flex;
    align-items: center;
    span {
      margin-top: -18px;
      margin-left: 20px;
    }
  }
  span {

    font-size: 16px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 700;
  }
  .fir {
    // margin-right: 14px;
    width: 166px;
    height: 100px;
    position: relative;
    background: url("../../assets/img/tycx.png") no-repeat;
    background-size: 100% 105%;
  }
  .sec {
    width: 166px;
    height: 100px;
    position: relative;
    background: url("../../assets/img/tyadd.png") no-repeat;
    background-size: 100% 105%;
  }
  .thr {
    // margin-right: 14px;
    width: 166px;
    height: 100px;
    position: relative;
    background: url("../../assets/img/tywzf.png") no-repeat;
    background-size: 100% 105%;
  }
  .for {
    width: 166px;
    height: 100px;
    position: relative;
    background: url("../../assets/img/tyyzf.png") no-repeat;
    background-size: 100% 105%;
  }
  .fif{
    width: 166px;
    height: 100px;
    position: relative;
    background: url("../../assets/img/tyadd.png") no-repeat;
    background-size: 100% 105%;
  }
  .mid_src {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 16px;
    right: 23px;
  }
}

.main_midrow {
  margin-top: 10px;
  // justify-content: center;
  // padding:0px 15px;
  width: 100vw;
  box-sizing: border-box;
  padding: 0px 14px;
  > div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      margin-top: -14px;
      margin-left: 30px;
    }
  }
  span {

    font-size: 16px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 700;
  }
  .firh {
    // margin-right: 14px;
    width: 100%;
    height: 100px;
    position: relative;
    background: url("../../assets/img/query_row.png") no-repeat;
    background-size: 100% 95%;
  }
  .sech {
    width: 100%;
    height: 100px;
    position: relative;
    background: url("../../assets/img/add_row.png") no-repeat;
    background-size: 100% 95%;
  }
  .fifh{
    width: 100%;
    height: 100px;
    position: relative;
    background: url("../../assets/img/add_row.png") no-repeat;
    background-size: 100% 95%;
  }
  .thrh {
    // margin-right: 14px;
    width: 100%;
    height: 100px;
    position: relative;
    background: url("../../assets/img/pay_row.png") no-repeat;
    background-size: 100% 95%;
  }
  .forh {
    width: 100%;
    height: 100px;
    position: relative;
    background: url("../../assets/img/paid_row.png") no-repeat;
    background-size: 100% 95%;
  }
  .mid_src {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 20px;
    right: 30px;
  }
}

.mid_bot {
  margin: 0px auto;
  // margin-top: 20px;
  width: 345px;
  height: 250px;
  background: #ffffff;
  box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-bottom: 42px;
  padding: 14px 16px;
  box-sizing: border-box;
  .m_top {
    display: flex;
    align-items: center;

    font-size: 16px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 700;
    > img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  .m_mid {
    display: flex;
    align-items: center;
    margin-top: 14px;
    height: 100px;
    box-sizing: border-box;
    border-top: 1px solid #eeeeee;
    border-bottom: 1px solid #eeeeee;
    .chartBox {
      padding-top: 10px;
    }
    .countM {
      width: 220px;
      display: flex;
      // justify-content: space-between;
    }
    .pay {
      margin-left: 20px;
      word-break: break-all;
      width: 100px;
      margin-right: 30px;
    }
    .alreadyPay {
      width: 80px;
      word-break: break-all;
      position: relative;
      &::after {
        content: "";
        width: 1px;
        height: 27px;
        background: #f6f6f6;
        position: absolute;
        top: 14px;
        left: -20px;
      }
    }
    .payTol {
      width: 80px;
      word-break: break-all;

      font-size: 12px;
      color: #464a4c;
      letter-spacing: 0;
      line-height: 24px;
      font-weight: 400;
    }
    .payNo {

      font-size: 12px;
      color: #464a4c;
      letter-spacing: 0;
      line-height: 24px;
      font-weight: 400;
    }
  }
  .m_bot {
    display: flex;
    align-items: center;
    .countM {
      width: 220px;
      display: flex;
      // justify-content: space-between;
    }
    .pay {
      word-break: break-all;
      width: 100px;
      margin-left: 20px;
      margin-right: 30px;
    }
    .alreadyPay {
      width: 80px;
      word-break: break-all;
      position: relative;
      &::after {
        content: "";
        width: 1px;
        height: 27px;
        background: #f6f6f6;
        position: absolute;
        top: 14px;
        left: -20px;
      }
    }
    .payTol {
      width: 80px;
      word-break: break-all;

      font-size: 12px;
      color: #464a4c;
      letter-spacing: 0;
      line-height: 24px;
      font-weight: 400;
    }
    .payNo {

      font-size: 12px;
      color: #464a4c;
      letter-spacing: 0;
      line-height: 24px;
      font-weight: 400;
    }
  }
}
.topBox {
  width: 94vw;
  position: relative;
  left: 50%;
  margin-left: -47vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  > div {
    text-align: center;
    width: 50%;
    position: relative;
    margin-top: 15px;
    font-size: 14px;
    span {
      display: block;
      margin-top: 10px;
      position: absolute;
      top: 16px;
      left: 20px;
      color: #fff;
      font-weight: bold;
    }
  }
}
.content {
  width: 94vw;
  position: relative;
  left: 50%;
  margin-left: -47vw;
  margin-top: 20px;
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    img {
      width: 16px;
      position: relative;
      top: -3px;
    }
    span {
      font-size: 16px;
      margin-left: 5px;
    }
  }
  .itemBox {
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 24px;
    padding: 30px 10px 15px 10px;
    .total {
      text-align: center;
      font-size: 14px;
      span {
        font-weight: bold;
        margin-left: 5px;
        font-size: 15px;
      }
    }
    .amt {
      text-align: right;
      font-size: 12px;
      color: #333;
    }
  }
}
.van-progress {
  margin: 25px 0;
}
</style>
